<template>
  <icon class="security" v-tooltip="'Sensitive data'"></icon>
</template>

<script lang="ts">
  import Vue from 'vue';

  export default Vue.extend({
  });
</script>